
<div class="clickable" (click)="onClick($event)" [cdkContextMenuTriggerFor]="contextMenu">
  <ng-content />
</div>

<ng-template #contextMenu>
  <div class="context-menu" cdkMenu>
    <button class="context-menu-item" (click)="openInNewTab($event)" cdkMenuItem>{{('windowtabs:openInNewTab' | translate)()}}</button>
    <button class="context-menu-item" (click)="openInNewWindow($event)" cdkMenuItem>{{('windowtabs:openInNewWindow' | translate)()}}</button>
  </div>
</ng-template>
